import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { postSupplementaryUnits } from '../../../api/v2/load';

export const useSupplementaryUnits = ({ visible, spreadsheetHandle, prepareProductList, GBimport, GBexport }) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const hasSpreadsheetData = spreadsheetHandle.current?.excelState?.rows?.length > 0;
    const isGBRoute = GBimport || GBexport;
    const shouldCallAPI = visible && hasSpreadsheetData && isGBRoute;

    if (!shouldCallAPI) return;

    fetchUnitItems();
  }, [visible, spreadsheetHandle.current?.excelState?.rows?.length, GBimport, GBexport]);

  const getUnitsTooltipData = (filteredList, suppData) => {
    return filteredList.map((_item, index) => {
      const suppUnit = suppData[index];
      const displayUnit = suppUnit?.supplementaryUnit || suppUnit?.supplementaryUnitImport;
      const importLabel = !!suppUnit?.supplementaryUnitImport ? '(Import)' : '';
      return {
        itemId: index + 1,
        error: false,
        ...(displayUnit && { quantity2warn: `Supp Unit${importLabel}: ${displayUnit}` }),
      };
    });
  };

  const setUnitsToolTip = (warningData) => {
    const updateFunc = (prevRows) => {
      const keys = spreadsheetHandle.current.excelState.config.map((c) => c.key);
      const quantity2Index = keys.findIndex((e) => e === 'quantity2');
      prevRows.forEach((row, i) => {
        if (row[quantity2Index]) {
          row[quantity2Index].warn = warningData[i]?.quantity2warn || null;
        }
      });
      return [...prevRows];
    };
    spreadsheetHandle.current.excelDispatch({ type: 'set', detail: updateFunc });
  };

  const fetchUnitItems = async () => {
    const filteredList = prepareProductList(true, true);
    if (!filteredList || filteredList.length === 0) return;

    const supplementaryUnitsItems = filteredList.map((item, index) => ({
      itemId: index + 1,
      commcode: item.commoditycode,
      origin: item.origin,
    }));

    try {
      const suppData = await queryClient.fetchQuery({
        queryKey: ['postSupplementaryUnits', supplementaryUnitsItems, GBimport],
        queryFn: () => postSupplementaryUnits(supplementaryUnitsItems, GBimport),
        staleTime: Infinity,
      });

      if (Array.isArray(suppData)) {
        setUnitsToolTip(getUnitsTooltipData(filteredList, suppData));
      }
    } catch (error) {
      console.error('Supplementary units API error:', error);
    }
  };
};
